import { API_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import { Project, Section } from '@Models/types';

export const testrailAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  return {
    getProj: async () => {
      const res = await axios.get<{ Projects: Project[] }>('/api/getProj');
      return res.data.Projects;
    },

    getFavProj: async () => {
      const res = await axios.get<{ FavProj: Project[] }>('/api/getFavProj');
      return res.data.FavProj;
    },

    saveFavProj: async (favoriteProjectIds: Project[]) => {
      const res = await axios.post('/api/setFavProj', {
        favoriteProjectIds,
      });

      return res.data;
    },

    getSections: async (project_id: number) => {
      const res = await axios.post<{ Sections: Section[] }>(
        '/api/getSections',
        {
          project_id,
        }
      );
      return res.data.Sections;
    },
  };
};
